module.exports = {
  QueryBalance: 'ค้นหาลูกค้าที่ชำระเงินล่วงหน้า',
  QueryDetail: 'ค้นหารายละเอียดการชำระเงินล่วงหน้า',
  BalanceDetail: 'รายละเอียดการเปลี่ยนแปลงยอดคงเหลือ',
  FinanceBalance: 'ยอดคงเหลือด้านการเงินและการดำเนินงาน',
  SendBalance: 'ส่งรายชื่อ',
  QuerySendBalanceState: 'ตรวจสอบสถานะการส่งรายชื่อ',
  InitializeBalance: 'เริ่มต้นยอดคงเหลือ',
  QuickSearchBalance: 'ค้นหาด่วน: รหัสลูกค้า',
  CustomerName: 'ชื่อลูกค้า',
  CustomerCode: 'รหัสลูกค้า',
  SalesName: 'การขาย',
  ParentBranchName: 'ชื่อองค์กรระดับสูง',
  ParentBranchCode: 'รหัสองค์กรระดับสูง',
  BranchName: 'ชื่อหน่วยงานที่สังกัด',
  BranchCode: 'รหัสหน่วยงานที่สังกัด',
  BranchId: 'หน่วยงานรับฝาก',
  Balance: 'ยอดคงเหลือ',
  DateCreated: 'วันที่สร้าง',
  State: 'สถานะการซิงค์รายชื่อ',
  SubmittingAmount: 'จำนวนเงินที่กำลังส่ง',
  ShowChildData: 'แสดงบริษัทลูก',
  ChangeAmount: 'การเปลี่ยนแปลงจำนวนเงิน',
  ChangeType: 'ประเภทการเปลี่ยนแปลงยอดคงเหลือ',
  LatestBalance: 'ยอดคงเหลือล่าสุด',
  ChangeDate: 'วันที่เกิดขึ้น',
  Currency: 'สกุลเงิน',
  JobNo: 'รหัสธุรกิจ',
  FinanceUpdateDate: 'วันที่อัปเดตการเงินและการดำเนินงาน',
  SyncDate: 'วันที่ซิงค์',
  CheckBalanceTitle: 'ยอดคงเหลือชำระล่วงหน้าไม่เพียงพอ',
  CheckBalanceDetail: '{0}, [{1}]{2}: ยอดคงเหลือปัจจุบัน RMB {3} ธุรกิจที่กำลังส่งใช้ไปแล้ว RMB {4} การส่งครั้งนี้ RMB {5}',
  CheckBalanceDetail2: '[{0}]{1}: ยอดคงเหลือปัจจุบัน RMB {2} ธุรกิจที่กำลังส่งใช้ไปแล้ว RMB {3} การส่งครั้งนี้ RMB {4}',
  CustSettlement: 'วิธีการชำระเงินของลูกค้า',
  InstCode: 'รหัสสาขา',
  InstName: 'ชื่อสาขา',
  SrcSystem: 'ระบบธุรกิจ',
  AdvBalance: 'ยอดเงินฝากล่วงหน้าปัจจุบัน',
  OrderType: 'ประเภทธุรกิจ',
  BlacklistRemark: 'หมายเหตุบัญชีดำ',
  AddedToBlacklist: '{0} ถูกเพิ่มเข้าในบัญชีดำแล้ว',
  BalanceInitialized: 'หลังจากเริ่มต้นยอดคงเหลือแล้ว ลูกค้า "ชำระล่วงหน้า" ไม่สามารถเปลี่ยนกลับเป็น "คิดเป็นหนี้" ได้',
  CustomerCodeDuplicate: 'รหัสลูกค้าซ้ำ',
  NoMatchStateBySelected: 'ไม่มีรายการที่เลือกที่มีสถานะเป็น [{0}]',
  SendCustomerInfo: 'ส่งรายชื่อ',
  SendCustomerRemind: '*เตือน: โปรดยืนยันว่ารหัสและชื่อหน่วยงานที่ลูกค้าสังกัดตรงกับรหัสและชื่อหน่วยงานรับเงินในระบบการเงินและการดำเนินงาน หากไม่ตรงกัน จะไม่สามารถซิงค์ยอดคงเหลือและข้อมูลการเติมเงินได้'
}
